import type { FlattenedSectionProps } from "../../../../components/Questionnaire/Section";
import type { QuestionnaireState } from "../../types";

export const handleShowQuestionAction = (
  state: QuestionnaireState,
  payload: string, // question name
): QuestionnaireState => {
  const { sections: sectionsFromState, currentSectionIndex, mode } = state;
  const sections = sectionsFromState as unknown as FlattenedSectionProps[];
  const sectionIndex = sections.findIndex(({ questions }) =>
    questions.some(q => q.name === payload),
  );

  const isStacked = mode === "stacked-sections";

  return {
    ...state,
    currentSectionIndex:
      isStacked || sectionIndex === -1 ? currentSectionIndex : sectionIndex,
    selectedQuestion: payload,
    changedQuestions: [],
  };
};
